module.exports = __webpack_public_path__ + "/images/cover-retailers-box-it.218b92f.png";